.dialog {
  /* The reset zeroes every margin; the browser centres a modal <dialog> with `margin: auto`. */
  margin: auto;
  width: calc(100% - var(--space-6));
  max-height: calc(100dvh - var(--space-7));
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background-color: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

.dialog::backdrop {
  background-color: var(--color-overlay);
}

.dialog[open] {
  display: flex;
  animation: rise var(--transition-normal);
}

.sm {
  max-width: 28rem;
}

.md {
  max-width: 38rem;
}

.lg {
  max-width: 52rem;
}

.panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100dvh - var(--space-7));
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-5) var(--space-3) var(--space-6);
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding-top: var(--space-1);
}

.title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
}

.description {
  font-size: var(--font-size-md);
  color: var(--color-text-muted);
}

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-3) var(--space-6) var(--space-6);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-6);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-surface-2);
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(0.5rem);
  }
}
